define('common/commands',["require", "exports"], function (require, exports) {
    "use strict";
    var DelegateCommand = (function () {
        function DelegateCommand(target, context) {
            this._target = target;
            this._context = context;
        }
        DelegateCommand.prototype.execute = function (param) {
            this._target.call(this._context, param);
        };
        return DelegateCommand;
    }());
    exports.DelegateCommand = DelegateCommand;
});

